import sanityConfig from '../../sanity.config';
import * as React from 'react';
import {Image} from '@shopify/hydrogen';
import imageUrlBuilder from '@sanity/image-url';
import {Lightbox} from 'yet-another-react-lightbox';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

interface FullImageGalleryProps {
  component: any;
}

const builder = imageUrlBuilder(sanityConfig);
function urlFor(source: any): string {
  return builder.image(source).toString();
}

export function FullImageGallery({component}: FullImageGalleryProps) {
  const [open, setOpen] = React.useState(false);
  const [activeIndex, setActiveIndex] = React.useState(0);

  const slides: any[] = [];
  component.images.forEach((image: any) => {
    slides.push({src: urlFor(image?.image)});
  });

  const thumbnailsRef = React.useRef(null);

  const slideToPhoto = (index) => {
    setActiveIndex(index);
    const imagesContainer = document.getElementById('gallery-images');
    const child = imagesContainer.children[index];
    imagesContainer.style.left = -1 * child.offsetLeft + 'px';
  };
  return (
    <div className="specs mt-10 image-panels" id="st-gallery">
      <div className="gallery">
        <div className="images relative transition-all" id="gallery-images">
          {component.images?.map((image: any, index: number) => {
            return (
              <Image
                key={image?.image.src}
                src={urlFor(image?.image)}
                alt=""
                height="auto"
                width="auto"
                onClick={() => setOpen(true)}
                className={`cursor-pointer ${
                  activeIndex == index ? 'active' : ''
                }`}
              />
            );
          })}
        </div>
        <div className="dots">
          {component.images?.map((image: any, index: number) => {
            return (
              <span
                aria-hidden="true"
                key={index}
                className={`dot ${activeIndex == index ? 'active' : ''}`}
                onClick={() => {
                  slideToPhoto(index);
                }}
              ></span>
            );
          })}
        </div>
        <Lightbox
          plugins={[Thumbnails]}
          thumbnails={{ref: thumbnailsRef}}
          open={open}
          close={() => setOpen(false)}
          slides={slides}
          index={activeIndex}
        />
      </div>
    </div>
  );
}
